import AddConsumerScreen from "../modules/users/AddConsumerScreen"

export default function AddConsumer() {
  return (
    <>
      <AddConsumerScreen />
    </>
  )
}
